import useCartCount from '@/components/customers/cart/hooks/useCartCount';
import getImageUrl from '@/utils/images';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;

const CartWrapper = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.colors.charcoal};
  display: flex;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: 16px;
  height: ${({ showLabel }) => showLabel ? '48px' : 'auto' }

  img {
    width: 17px;
    height: 17px;
    margin-right: ${({ showLabel }) => showLabel ? '12.5px' : 0 }
  }

  .cart-items-count-badge {
    align-items: center;
    background-color: ${({ theme }) => theme.colors.olive};
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.white};
    display: flex;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 11px;
    font-weight: 100;
    height: 17px;
    justify-content: center;
    left: 15px;
    line-height: 20px;
    position: absolute;
    text-align: center;
    top: -3px;
    width: 17px;
  }
`;

function RebrandedCartButton({ className, showLabel = false }) {
  const { cartCount } = useCartCount();

  return (
    <Wrapper className={className}>
      <Link aria-label="cart" to="/cart">
        <CartWrapper showLabel={showLabel}>
          <img src={getImageUrl("nav/shop_icon.svg")} alt={''}/>
          {cartCount > 0 && (
            <span className="cart-items-count-badge">{cartCount}</span>
          )}
          { showLabel && <>Cart</> }
        </CartWrapper>
      </Link>
    </Wrapper>
  );
}

export default RebrandedCartButton;
